import { ItemViewModel } from '@/definitions/view-models';
import { Webhook } from '@/api';
import { MultisidebarItem } from '@/store/multisidebar/types';

export default async function ({ model }: MultisidebarItem<ItemViewModel<Webhook>>) {
  return { label: model.item?.name || '' };
}
